import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ServerUrl } from '../../../../api/ServerUrl';
import { ProtectAPi } from '../../../../api/ProtectAPi';
import swal from 'sweetalert';
import JoditEditor from "jodit-react";
import BackButton from '../../../tools/BackButton';

const ProductEdit = () => {
    const { http } = ProtectAPi();
    const { id } = useParams();
    const navigate = useNavigate();
    const editor = useRef(null);

    const [loader, setLoader] = useState('off');
    const [productName, setProductName] = useState('');
    const [productSlug, setProductSlug] = useState('');
    const [layoutDescription, setLayoutDescription] = useState('');
    const [layoutImages, setLayoutImages] = useState([]);
    const [oldImage, setOldImages] = useState([]);
    const [deletedOldImageIds, setDeletedOldImageIds] = useState([]);
    const [categoryNames, setCategoryNames] = useState([]);
    const [selectedCategoryName, setSelectedCategoryName] = useState('');
    const [productStatus, setProductStatus] = useState('');
    const [productHomeShow, setProductHomeShow] = useState('');

    useEffect(() => {
        http.get(`/get-single-product/${id}`).then(res => {
            setProductName(res.data.data.product_name);
            setProductSlug(res.data.data.slug);
            setLayoutDescription(res.data.data.description);
            setSelectedCategoryName(res.data.data.category_id);
            setProductStatus(res.data.data.status);
            setProductHomeShow(res.data.data.home_show);
            setOldImages(res.data.images.map(img => ({ ...img, alt: img.alt || '' })));
        });

        http.get('/get-all-product-category')
            .then(res => {
                setCategoryNames(res.data || []);
            });
    }, []);

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        const newImages = files.map(file => ({ file, preview: URL.createObjectURL(file), alt: '' }));
        setLayoutImages(prev => [...prev, ...newImages]);
    };

    const handleNewAltChange = (index, value) => {
        const updated = [...layoutImages];
        updated[index].alt = value;
        setLayoutImages(updated);
    };

    const handleOldAltChange = (index, value) => {
        const updated = [...oldImage];
        updated[index].alt = value;
        setOldImages(updated);
    };

    const handleImageRemove = (index) => {
        const updated = [...layoutImages];
        updated.splice(index, 1);
        setLayoutImages(updated);
    };

    const handleOldImageDelete = (imageId) => {
        setOldImages(prev => prev.filter(img => img.id !== imageId));
        setDeletedOldImageIds(prev => [...prev, imageId]);
    };

    const submitForm = () => {
        setLoader('on');
        const formData = new FormData();
        formData.append('product_name', productName);
        formData.append('description', layoutDescription);
        formData.append('category_id', selectedCategoryName);
        formData.append('status', productStatus);
        formData.append('home_show', productHomeShow);
        formData.append('slug', productSlug);


        layoutImages.forEach((img, index) => {
            formData.append(`images[${index}]`, img.file);
            formData.append(`alt_texts[${index}]`, img.alt);
        });

        oldImage.forEach((img, index) => {
            formData.append(`old_image_ids[${index}]`, img.id);
            formData.append(`old_image_alts[${index}]`, img.alt);
        });

        deletedOldImageIds.forEach((id, index) => {
            formData.append(`deleted_old_image_ids[${index}]`, id);
        });

        http.post(`/update-product/${id}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => {
            setLoader('off');
            if (res.data.status === '200') {
                swal('Success', res.data.msg, 'success');
                navigate('/admin/products-list');
            } else {
                swal('Error', 'Please fix validation errors.', 'error');
            }
        }).catch(err => {
            setLoader('off');
            console.error(err);
        });
    };

    const editorConfig = useMemo(() => ({
        readonly: false,
        placeholder: 'Start typing...',
        uploader: { insertImageAsBase64URI: true }
    }), []);

    return (
        <div className="main-content">
            <section className="section">
                <div className="section-body">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-primary">
                                <div className="card-body">

                                    <div className="d-flex justify-content-between mb-3">
                                        <h5>Edit Product</h5>
                                        <BackButton />
                                    </div>




                                    <div className="form-group mt-4">
                                        <label>Upload Multiple Images</label>
                                        <input type="file" className="form-control" multiple onChange={handleImageChange} />
                                    </div>
                                    <div className="row mt-3">
                                        {oldImage.map((img, i) => (
                                            <div key={i} className="col-md-3 mb-4">
                                                <div className="border p-2 rounded shadow-sm">
                                                    <img src={`${ServerUrl}/backend/img/product/${img.image}`} className="img-fluid mb-2" style={{ height: '150px', width: '100%' }} />
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Alt text for this image"
                                                        value={img.alt}
                                                        onChange={e => handleOldAltChange(i, e.target.value)}
                                                        style={{ height: '30px' }}
                                                    />
                                                    <button className="btn btn-danger btn-sm w-100 mt-2" onClick={() => handleOldImageDelete(img.id)}>Remove</button>
                                                </div>
                                            </div>
                                        ))}

                                        {layoutImages.map((img, i) => (
                                            <div key={i} className="col-md-3 mb-4">
                                                <div className="border p-2 rounded shadow-sm">
                                                    <img src={img.preview} className="img-fluid mb-2" style={{ height: '150px', width: '100%' }} />
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Alt text for this image"
                                                        value={img.alt}
                                                        onChange={e => handleNewAltChange(i, e.target.value)}
                                                        style={{ height: '30px' }}
                                                    />
                                                    <button className="btn btn-danger btn-sm w-100 mt-2" onClick={() => handleImageRemove(i)}>Remove</button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Product Name</label>
                                                <input type="text" className="form-control" value={productName} onChange={e => setProductName(e.target.value)} />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Slug (Optional)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={productSlug}
                                                    onChange={e => setProductSlug(e.target.value)}
                                                    placeholder="Enter slug"
                                                />
                                            </div>
                                        </div>


                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Select Category</label>
                                                <select className="form-control" value={selectedCategoryName} onChange={e => setSelectedCategoryName(e.target.value)}>
                                                    <option value="">Select a category</option>
                                                    {categoryNames.map((cat, i) => (
                                                        <option key={i} value={cat.id}>{cat.name} ({cat.group_name})</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Status</label>
                                                <select className="form-control" value={productStatus} onChange={e => setProductStatus(e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option value="1">Active</option>
                                                    <option value="0">De-Active</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Home Show</label>
                                                <select className="form-control" value={productHomeShow} onChange={e => setProductHomeShow(e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option value="1">Active</option>
                                                    <option value="0">De-Active</option>
                                                </select>
                                            </div>
                                        </div>  
                                    </div>

                                    <div className="form-group mt-4">
                                        <label>Description</label>
                                        <JoditEditor
                                            ref={editor}
                                            value={layoutDescription}
                                            config={{ ...editorConfig, height: 400 }}
                                            tabIndex={1}
                                            onBlur={newContent => setLayoutDescription(newContent)}
                                            onChange={() => { }}
                                        />
                                    </div>

                                    <div className="mb-3 mt-4">
                                        {loader === 'off' ? (
                                            <button className="btn btn-lg btn-primary" onClick={submitForm}>Update Product</button>
                                        ) : (
                                            <div className="spinner-border text-dark" role="status"></div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ProductEdit;
